/* eslint-disable */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

class EchoService {
  private echoInstance: Echo<any> | null = null;

  createEcho(token: string, tenant?: number): Echo<any> {
    this.echoInstance = new Echo({
      broadcaster: 'reverb',
      key: process.env.VUE_APP_REVERB_APP_KEY,
      wsHost: process.env.VUE_APP_REVERB_HOST,
      wsPort: Number(process.env.VUE_APP_REVERB_PORT) || 8082,
      wssPort: Number(process.env.VUE_APP_REVERB_PORT) || 8082,
      forceTLS: (process.env.VUE_APP_REVERB_SCHEME ?? 'https') === 'https',
      enabledTransports: ['ws', 'wss'],
      authEndpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
          tenant,
        },
      },
    });

    return this.echoInstance;
  }

  getEcho(): Echo<any> | null {
    return this.echoInstance;
  }
}

const echoService = new EchoService();
export default echoService;
